import Extend from 'flarum/common/extenders';
import TermsAndConditionsPage from './TermsAndConditionsPage';
export default [new Extend.Routes() //
.add('diaTheme.terms', '/obchodni-podminky', TermsAndConditionsPage)];